import { CustomObject } from '@shared/modules/custom-objects/custom-objects.types';
import { JupiterStateFeatureSupportModel, LabelsSlot } from './types';
import { RelatedToType } from '@shared/enums';

export const getLabelSlots = (tsObject: CustomObject): LabelsSlot => {
  return {
    ADD: tsObject.label ? `Add new ${tsObject.label}` : 'Add',
    EXPORT_CSV: 'Export as CSV',
  };
};

export const getFeatureSupport = (obj: CustomObject): JupiterStateFeatureSupportModel => {
  if (obj.id) {
    return {
      groupedTable: false,
      bulkActions: {
        enabled: false,
        actions: {
          deleteRows: false,
          updateTags: false,
        },
      },
      homeActions: {
        actions: {
          add: true,
          export: true,
        },
      },
      gridActions: {
        enabled: true,
        actions: {
          logCall: false,
          logMeeting: false,
          logSocialMedia: false,
          edit: true,
          delete: true,
          openDetails: true,
        },
      },
      tags: {
        enabled: false,
      },
      detailsMainTabs: {
        backButton: true,
        details: true,
        files: true,
        notes: true,
        activities: true,
        engagements: false,
        tasks: true,
        crmTasks: false,
        linkedObjects: true,
        deals: false,
        leases: false,
        nearby: false,
        contacts: false,
        dispositions: false,
        loanQuotes: false,
        financials: false,
        contextMenu: {
          enabled: true,
          actions: {
            layoutManager: true,
            delete: true,
            duplicate: true,
            changeLayout: true,
            generateMergeDocument: true,
          },
        },
      },
      panels: {
        'crm-table-panel': false,
        form: true,
        comments: true,
        table: true,
        images: true,
        matrix: true,
      },
    };
  }

  const isCrm = [RelatedToType.Contact, RelatedToType.Company].includes(obj.name as RelatedToType);
  const canShowLeases = ![RelatedToType.Contact, RelatedToType.Company, RelatedToType.PropertyTenant].includes(
    obj.name as RelatedToType,
  );
  const canShowGalleryPanel = canShowLeases;
  const canShowMatrixPanel = true;
  const canShowTablePanel = RelatedToType.PropertyTenant !== obj.name;
  const canShowAddButton = RelatedToType.PropertyTenant !== obj.name;
  const canShowExportButton = RelatedToType.PropertyTenant !== obj.name;

  return {
    groupedTable: false,
    bulkActions: {
      enabled: RelatedToType.PropertyTenant !== obj.name,
      actions: {
        deleteRows: false,
        updateTags: true,
      },
    },
    homeActions: {
      actions: {
        add: canShowAddButton,
        export: canShowExportButton,
      },
    },
    gridActions: {
      enabled: RelatedToType.PropertyTenant !== obj.name,
      actions: {
        logCall: true,
        logMeeting: true,
        logSocialMedia: true,
        edit: false,
        delete: false,
        openDetails: false,
      },
    },
    tags: {
      enabled: isCrm,
    },
    detailsMainTabs: {
      backButton: true,
      details: true,
      files: true,
      notes: true,
      activities: true,
      engagements: isCrm,
      crmTasks: isCrm,
      tasks: RelatedToType.PropertyTenant !== obj.name,
      linkedObjects: RelatedToType.PropertyTenant !== obj.name,
      leases: canShowLeases,
      deals: RelatedToType.Property === obj.name,
      nearby: RelatedToType.Property === obj.name,
      loanQuotes: RelatedToType.Project === obj.name,
      dispositions: RelatedToType.Project === obj.name,
      contacts: RelatedToType.Project === obj.name,
      financials: false,
      contextMenu: {
        enabled: true,
        actions: {
          layoutManager: true,
          delete: true,
          duplicate: true,
          changeLayout: true,
          generateMergeDocument: false,
        },
      },
    },
    panels: {
      'crm-table-panel': isCrm,
      form: true,
      comments: true,
      table: canShowTablePanel,
      images: canShowGalleryPanel,
      matrix: canShowMatrixPanel,
    },
  };
};
